module.exports = __webpack_public_path__ + "static/img/slide_6_en.55a26d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_6_en.svg
// module id = YHuX
// module chunks = 0